import Layout from './Layout'

export { default as ContentPageLayout } from './subLayouts/ContentPageLayout'
export { default as HomePageLayout } from './subLayouts/HomePageLayout'

export default Layout
